<template>
  <div class="orders">
    <div class="title">
      <div class="explanation--search">Search past orders:</div>
      <input
        v-model="searchNumber"
        placeholder="Enter order number.."
        class="order--search"
      />
      <div @click="loadOrders()" class="refresh">
        Refresh <img class="icon" src="../assets/refresh.svg" />
      </div>
    </div>

    <div class="title--border"></div>
    <div v-if="loading === true" class="loading--overlay">
      <pulse-loader
        :loading="loading"
        :color="color"
        :size="size"
      ></pulse-loader>
    </div>
    <b-modal v-model="showModal">
      Create call-tags for provided address and email PDF to provided email
      address. Enter the shipping cost in the provided input field.
    </b-modal>

    <b-modal v-model="showModal4">
      Reject tires if noticeable signs of being mounted/having wear. Click
      "Reject refund" and then notify Chad or Nic.
    </b-modal>

    <b-tabs content-class="mt-3">
      <b-tab>
        <template #title> Awaiting tags ({{ filteredList.length }}) </template>
        <div class="order--row" v-for="order3 in filteredList" :key="order3.id">
          <div class="order--item">
            <div class="order--item--1">
              <span>Order #{{ order3.orderNumber }} </span>
              <div class="order--enter">
                <img
                  @click="showModal = !showModal"
                  class="help"
                  src="../assets/help.svg"
                />
                <input
                  class="input--shipping"
                  v-model="order3.returnShippingCost"
                  placeholder="Enter shipping cost here.."
                />
                <button
                  class="button-action"
                  :disabled="order3.returnShippingCost.length < 1"
                  @click="shipTags(order3)"
                >
                  Email & tags sent
                </button>
              </div>
            </div>
            <div class="order--details--row">
              <div class="order--item--2">
                <span class="order--title">Customer details: </span>
                <span> {{ order3.firstName }} {{ order3.lastName }} </span>
                {{ order3.emailAddress }} {{ order3.phoneNumber }} 
              </div>
              <div class="order--item--2">
                <span class="order--title">Shipping details: </span>
                <span class="order--title">Shipping details </span>
                <span>
                {{ order3.address.unitNumber }} {{ order3.address.name }}
              </span>
              <span>
                {{ order3.address.city }},
                {{ order3.address.province }}
              </span>
              <span> {{ order3.address.postalCode }} </span>
              </div>
              <div class="order--item--2">
                <span class="order--title">Product details </span>
                <div v-for="item in order3.items" :key="item.id">
                  <span v-if="item.universal.item">
                    Order:
                    {{ item.universal.quantity.$numberInt }} x
                    {{ item.universal.item.MSPN }}
                    <br />
                    {{ item.universal.item.Brand }}
                    {{ item.universal.item["Product Line"] }}

                    {{ item.universal.item["Size Description"] }}

                    <br />
                    @ ${{ item.universal.item.RetailPrice }}
                  </span>
                  <span v-else>
                    Order:
                    {{ item.front.quantity.$numberInt }} x
                    {{ item.front.item.MSPN }}
                    <br />
                    {{ item.front.item.Brand }}
                    {{ item.front.item["Product Line"] }}
                    {{ item.front.item["Size Description"] }}<br />
                    @ ${{ item.front.item.RetailPrice }}
                    <br />
                    Order:
                    {{ item.rear.quantity.$numberInt }} x
                    {{ item.rear.item.MSPN }}
                    <br />
                    {{ item.rear.item.Brand }}
                    {{ item.rear.item["Product Line"] }}
                    {{ item.rear.item["Size Description"] }}<br />
                    @ {{ item.rear.item.RetailPrice }}
                  </span>
                  <span v-if="order3.vehicle.length > 0">
                    <span v-for="vehicle in order3.vehicle" :key="vehicle.id"
                      >Vehicle: {{ vehicle.vehicle.years.name.$numberInt }}
                      {{ vehicle.vehicle.make.name }}
                      {{ vehicle.vehicle.models.name }}
                      {{ vehicle.vehicle.trims.trim }}</span
                    >
                  </span>
                  <span v-else>
                    <span>Vehicle: none</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <b-tab>
        <template #title>
          Tags printed/in transit ({{ filteredList2.length }})
        </template>
        <div
          class="order--row"
          v-for="order3 in filteredList2"
          :key="order3.id"
        >
          <div class="order--item" v-for="item in order3.items" :key="item.id">
            <div class="order--item--1">
              <span>Order #{{ order3.orderNumber }} </span>
              <div class="order--enter">
                <img
                  @click="showModal4 = !showModal4"
                  class="help"
                  src="../assets/help.svg"
                />
                <input
                  class="checkbox"
                  v-model="order3.returnedCheckbox"
                  type="checkbox"
                />
                <button
                  @click="itemReturnedandRejected(order3)"
                  :disabled="order3.returnedCheckbox === false"
                  class="button-action"
                >
                  Reject refund
                </button>
                <button
                  @click="itemReturnedandAccepted(order3)"
                  :disabled="order3.returnedCheckbox === false"
                  class="button-action"
                >
                  Accept refund
                </button>
              </div>
            </div>
            <div class="order--details--row">
              <div class="order--item--2">
                <span class="order--title">Customer details: </span>
                <span> {{ order3.firstName }} {{ order3.lastName }} </span>
                {{ order3.emailAddress }} {{ order3.phoneNumber }} 
              </div>
              <div class="order--item--2">
                <span class="order--title">Shipping details: </span>
                <span>
                {{ order3.address.unitNumber }} {{ order3.address.name }}
              </span>
              <span>
                {{ order3.address.city }},
                {{ order3.address.province }}
              </span>
              <span> {{ order3.address.postalCode }} </span>
              </div>
              <div class="order--item--2">
                <span class="order--title">Product details </span>
                <span v-if="item.universal.item">
                  {{ item.universal.quantity.$numberInt }} x
                  {{ item.universal.item.MSPN }}
                  {{ item.universal.item.Brand }}
                  {{ item.universal.item["Product Line"] }}</span
                >
                <span v-else>
                  {{ item.front.quantity.$numberInt }} x
                  {{ item.front.item.MSPN }}
                  {{ item.front.item.Brand }}
                  {{ item.front.item["Product Line"] }} <br />
                  {{ item.rear.quantity.$numberInt }} x
                  {{ item.rear.item.MSPN }}
                  {{ item.rear.item.Brand }}
                  {{ item.rear.item["Product Line"] }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </b-tab>

      <b-tab>
        <template #title>
          Declined returns ({{ filteredList4.length }})
        </template>
        <div
          class="order--row"
          v-for="order3 in filteredList4"
          :key="order3.id"
        >
          <div class="order--item" v-for="item in order3.items" :key="item.id">
            <div class="order--item--1">
              <span>Order #{{ order3.orderNumber }} </span>
              <div class="order--enter">
                <img
                  @click="showModal3 = !showModal3"
                  src="../assets/help.svg"
                  class="help"
                />
                <input
                  class="checkbox"
                  v-model="order3.returnedCheckbox"
                  type="checkbox"
                />
                <button
                  :disabled="order3.returnedCheckbox === false"
                  class="button-action"
                  @click="moveToPastOrders(order3)"
                >
                  Send back tires
                </button>
              </div>
            </div>
            <div class="order--details--row">
              <div class="order--item--2">
                <span class="order--title">Customer details: </span>
                <span> {{ order3.firstName }} {{ order3.lastName }} </span>
                {{ order3.emailAddress }} {{ order3.phoneNumber }} 
              </div>
              <div class="order--item--2">
                <span class="order--title">Shipping details: </span>
                <span>
                {{ order3.address.unitNumber }} {{ order3.address.name }}
              </span>
              <span>
                {{ order3.address.city }},
                {{ order3.address.province }}
              </span>
              <span> {{ order3.address.postalCode }} </span>
              </div>
              <div class="order--item--2">
                <span class="order--title">Product details </span>
                <span v-if="item.universal.item">
                  {{ item.universal.quantity.$numberInt }} x
                  {{ item.universal.item.MSPN }}
                  {{ item.universal.item.Brand }}
                  {{ item.universal.item["Product Line"] }}</span
                >
                <span v-else>
                  {{ item.front.quantity.$numberInt }} x
                  {{ item.front.item.MSPN }}
                  {{ item.front.item.Brand }}
                  {{ item.front.item["Product Line"] }} <br />
                  {{ item.rear.quantity.$numberInt }} x
                  {{ item.rear.item.MSPN }}
                  {{ item.rear.item.Brand }}
                  {{ item.rear.item["Product Line"] }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import axios from "axios";

var qs = require("qs");
var assert = require("assert");

var obj = qs.parse("a=c");
assert.deepEqual(obj, { a: "c" });

var str = qs.stringify(obj);
assert.equal(str, "a=c");

export default {
  data() {
    return {
      loading: false,
      searchNumber: "",
      trackingNumber: "",
      showModal2: false,
      shippingTags: "",
      showModal: false,
      showModal3: false,
      showModal4: false,
      one: false,
      two: false,
      three: false,
      four: false,

      // Note `isActive` is left out and will not appear in the rendered table
    };
  },
  components: {
    PulseLoader,
  },
  computed: {
    ...mapGetters(["orders", "ordersToShip", "fulfilledOrders", "user_id"]),
    sendTagsDisabled() {
      if (this.shippingTags.length < 1) {
        return true;
      } else {
        return false;
      }
    },
    filteredList() {
      return this.fulfilledOrders.filter((order) => {
        return (
          order.refundStarted === true &&
          order.refundInTransit === false &&
          order.refundAccepted === false &&
          order.refundRejected === false &&
          order.refundComplete === false &&
          order.orderNumber.includes(this.searchNumber)
        );
      });
    },
    filteredList2() {
      return this.fulfilledOrders.filter((order) => {
        return (
          order.refundStarted === true &&
          order.refundInTransit === true &&
          order.refundAccepted === false &&
          order.refundRejected === false &&
          order.refundComplete === false &&
          order.orderNumber.includes(this.searchNumber)
        );
      });
    },
    filteredList3() {
      return this.fulfilledOrders.filter((order) => {
        return (
          order.refundStarted === true &&
          order.refundInTransit === true &&
          order.refundAccepted === true &&
          order.refundRejected === false &&
          order.refundComplete === false &&
          order.orderNumber.includes(this.searchNumber)
        );
      });
    },
    filteredList4() {
      return this.fulfilledOrders.filter((order) => {
        return (
          order.refundStarted === true &&
          order.refundInTransit === true &&
          order.refundAccepted === false &&
          order.refundRejected === true &&
          order.refundComplete === false &&
          order.orderNumber.includes(this.searchNumber)
        );
      });
    },
    filteredList5() {
      return this.fulfilledOrders.filter((order) => {
        return (
          order.refundStarted === true &&
          order.refundInTransit === true &&
          order.refundAccepted === true &&
          order.refundRejected === false &&
          order.refundComplete === true &&
          order.orderNumber.includes(this.searchNumber)
        );
      });
    },
    isDisabled() {
      if (!this.trackingNumber) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    shipTags: async function(order3) {
      const user = localStorage.getItem("User");
      this.loading = true;
      const params = {};
      (params.user = user),
        await axios
          .post(
            process.env.VUE_APP_FULFILLED_PUT,
            {
              firstName: order3.firstName,
              lastName: order3.lastName,
              emailAddress: order3.emailAddress,
              phoneNumber: order3.phoneNumber,
              address: order3.address,
              items: order3.items,
              taxes: order3.taxes,
              fees: order3.fees,
              subtotal: order3.subtotal,
              total: order3.total,
              vehicle: order3.vehicle,
              orderNumber: order3.orderNumber,
              trackingNumber: order3.trackingNumber,
              invoiceNumber: order3.invoiceNumber,
              refundConfirmationCheckbox: false,
              returnedCheckbox: false,
              stripeRefundedCheckbox: false,
              returnShippingCost: order3.returnShippingCost,
              refundStarted: true,
              refundInTransit: true,
              refundAccepted: false,
              refundRejected: false,
              refundComplete: false,
            },
            {
              params: params,
              paramsSerializer: function(params) {
                return qs.stringify(params);
              },
            }
          )
          .then(() => {
            this.$store.dispatch("loadFulfilledOrders");
            console.log("loadpage");
            this.loading = false;
          })
          .catch((error) => console.log(error));
    },
    itemReturnedandAccepted: async function(order3) {
      const user = localStorage.getItem("User");
      this.loading = true;
      console.log("processrefund");
      const params = {};
      (params.user = user),
        await axios
          .post(
            process.env.VUE_APP_FULFILLED_PUT,
            {
              firstName: order3.firstName,
              lastName: order3.lastName,
              emailAddress: order3.emailAddress,
              phoneNumber: order3.phoneNumber,
              address: order3.address,
              items: order3.items,
              orderNumber: order3.orderNumber,
              trackingNumber: order3.trackingNumber,
              invoiceNumber: order3.invoiceNumber,
              refundConfirmationCheckbox: false,
              returnedCheckbox: false,
              stripeRefundedCheckbox: false,
              returnShippingCost: order3.returnShippingCost,
              refundStarted: true,
              refundInTransit: true,
              refundAccepted: true,
              refundRejected: false,
              refundComplete: false,
            },
            {
              params: params,
              paramsSerializer: function(params) {
                return qs.stringify(params);
              },
            }
          )
          .then(() => {
            this.$store.dispatch("loadFulfilledOrders");
            console.log("loadpage");
            this.loading = false;
          })
          .catch((error) => console.log(error));
    },
    itemReturnedandRejected: async function(order3) {
      const user = localStorage.getItem("User");
      this.loading = true;
      console.log("processrefund");
      const params = {};
      (params.user = user),
        await axios
          .post(
            process.env.VUE_APP_FULFILLED_PUT,
            {
              firstName: order3.firstName,
              lastName: order3.lastName,
              emailAddress: order3.emailAddress,
              phoneNumber: order3.phoneNumber,
              address: order3.address,
              items: order3.items,
              orderNumber: order3.orderNumber,
              trackingNumber: order3.trackingNumber,
              invoiceNumber: order3.invoiceNumber,
              refundConfirmationCheckbox: false,
              returnedCheckbox: false,
              stripeRefundedCheckbox: false,
              returnShippingCost: order3.returnShippingCost,
              refundStarted: true,
              refundInTransit: true,
              refundAccepted: false,
              refundRejected: true,
              refundComplete: false,
            },
            {
              params: params,
              paramsSerializer: function(params) {
                return qs.stringify(params);
              },
            }
          )
          .then(() => {
            this.$store.dispatch("loadFulfilledOrders");
            console.log("loadpage");
            this.loading = false;
          })
          .catch((error) => console.log(error));
    },
    cardRefunded: async function(order3) {
      const user = localStorage.getItem("User");
      console.log("processrefund");
      this.loading = true;
      const params = {};
      (params.user = user),
        await axios
          .post(
            process.env.VUE_APP_FULFILLED_PUT,
            {
              firstName: order3.firstName,
              lastName: order3.lastName,
              emailAddress: order3.emailAddress,
              address: order3.address,
              items: order3.items,
              orderNumber: order3.orderNumber,
              trackingNumber: order3.trackingNumber,
              invoiceNumber: order3.invoiceNumber,
              refundConfirmationCheckbox: false,
              returnedCheckbox: false,
              stripeRefundedCheckbox: false,
              returnShippingCost: order3.returnShippingCost,
              refundStarted: true,
              refundInTransit: true,
              refundAccepted: true,
              refundRejected: false,
              refundComplete: true,
            },
            {
              params: params,
              paramsSerializer: function(params) {
                return qs.stringify(params);
              },
            }
          )
          .then(() => {
            this.$store.dispatch("loadFulfilledOrders");
            console.log("loadpage");
            this.loading = false;
          })
          .catch((error) => console.log(error));
    },
    moveToPastOrders: async function(order3) {
      const user = localStorage.getItem("User");
      this.loading = true;
      console.log("processrefund");
      const params = {};
      (params.user = user),
        await axios
          .post(
            process.env.VUE_APP_FULFILLED_PUT,
            {
              firstName: order3.firstName,
              lastName: order3.lastName,
              emailAddress: order3.emailAddress,
              address: order3.address,
              items: order3.items,
              orderNumber: order3.orderNumber,
              trackingNumber: order3.trackingNumber,
              invoiceNumber: order3.invoiceNumber,
              refundConfirmationCheckbox: false,
              returnedCheckbox: false,
              stripeRefundedCheckbox: false,
              returnShippingCost: order3.returnShippingCost,
              refundStarted: false,
              refundInTransit: false,
              refundAccepted: false,
              refundRejected: false,
              refundComplete: false,
            },
            {
              params: params,
              paramsSerializer: function(params) {
                return qs.stringify(params);
              },
            }
          )
          .then(() => {
            this.$store.dispatch("loadFulfilledOrders");
            console.log("loadpage");
            this.loading = false;
          })
          .catch((error) => console.log(error));
    },
  },

  mounted() {
    this.$store.dispatch("loadFulfilledOrders");
  },
};
</script>

<style>
.checkbox {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  padding: 20px;
}

.help {
  width: 40px;
  cursor: pointer;
  margin-right: 5px;
  border-radius: 100px;
  padding: 8px;
}

.help:hover {
  background-color: rgb(235, 235, 235);
}
.explanation--search {
  font-weight: 500;
  font-size: 18px;
}
.order--search {
  height: 45px;
  width: 500px;

  font-size: 16px;
  padding: 10px;
  border-radius: 5px;
  border: solid 2px rgb(209, 209, 209);
  margin-left: 20px;
  outline: none;
}

.order--search:focus {
  border: solid 2px rgb(168, 168, 168);
}

.shipping--cost--input {
  height: 45px;
  border-radius: 5px;
  margin-right: 5px;
  outline: none;
  border: solid 1 px rgb(230, 230, 230);
}
</style>
